export const SETTING_TYPE = {
  SUBCATEGORY: 'Subcategory',
  CATEGORY: 'Category',
  COMPANY: 'Company',
  CONCRETE: 'ConcreteGrade',
  VEHICLE: 'Vehicle',
  GPSHISTORY: 'GPSHistory'
};
export const BC_TYPE = {
  PCF: 'PCF',
  ALW: 'ALW',
  TID: 'TID',
  MEG: 'MEG',
  VPB: 'VPB',
  VPK: 'VPK',
  MIC: 'MIC',
  STA: 'STA'
};

export const STEPCODE = {
  PCF10: 'PCF10',
  PCF20: 'PCF20',
  PCF30: 'PCF30',
  PCF35: 'PCF35',
  PCF40: 'PCF40',
  PCF50: 'PCF50',
  PCF60: 'PCF60',
  MIC10: 'MIC10',
  MIC20: 'MIC20',
  MIC30: 'MIC30',
  MIC35: 'MIC35',
  MIC40: 'MIC40',
  MIC50: 'MIC50',
  MIC60: 'MIC60',
  ALW10: 'ALW10',
  ALW20: 'ALW20',
  ALW30: 'ALW30',
  ALW40: 'ALW40',
  TID10: 'TID10',
  TID20: 'TID20',
  TID30: 'TID30',
  TID40: 'TID40',
  MEG10: 'MEG10',
  MEG20: 'MEG20',
  MEG30: 'MEG30',
  MEG40: 'MEG40',
  VPB10: 'VPB10',
  VPB20: 'VPB20',
  VPB30: 'VPB30',
  VPB35: 'VPB35',
  VPB40: 'VPB40',
  VPB50: 'VPB50',
  VPB60: 'VPB60',
  VPB70: 'VPB70',
  VPB80: 'VPB80',
  VPK10: 'VPK10',
  VPK20: 'VPK20',
  VPK30: 'VPK30',
  VPK35: 'VPK35',
  VPK40: 'VPK40',
  VPK50: 'VPK50',
  VPK60: 'VPK60',
  VPK70: 'VPK70',
  VPK80: 'VPK80',
  STA10: 'STA10',
  STA20: 'STA20',
  STA30: 'STA30',
  STA40: 'STA40'
};
